function ConsoleLogoPolyfill(_image, _imageText) {
  const img = new Image();

  function getBox(width, height) {
    return {
      char: '+',
      style: 'font-size: 1px; ' +
        'padding: ' + Math.floor(height / 2) + 'px ' + Math.floor(width / 2) + 'px;',
    };
  }

  img.onload = function () {
    const dim = getBox(this.width, this.height);
    const style = 'background: url(\'' + _image + '\');' +
      'background-size: ' + this.width + 'px ' + this.height + 'px;' +
      'color: transparent; background-repeat: no-repeat;';
    console.log('%c' + dim.char, dim.style + style);
    console.log(_imageText);
  };

  img.src = _image;
}

module.exports = ConsoleLogoPolyfill;



//////////////////
// WEBPACK FOOTER
// ./polyfills/console-logo.js
// module id = 711
// module chunks = 0